import React from "react";
import emailjs from 'emailjs-com';
import { Container, Button, Form, Row, Image } from "react-bootstrap";
import Hello from "../img/helloMyNameIs.png";


const API_SER = process.env.REACT_APP_SERVICE_KEY
const API_TEMP = process.env.REACT_APP_TEMPLATE_KEY
const API_USER = process.env.REACT_APP_USER_KEY

export default function ContactMe(props) {

  function sendEmail(e) {
    e.preventDefault();

    console.log(process.env.NODE_ENV);

    emailjs.sendForm(
      API_SER,
      API_TEMP,
      e.target,
      API_USER
    )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  }

  const redStar = <span>*</span>;
  return (
    <>
      <Container className="page-Title space-Bottom" fluid>
        <h1>*Contact Me*</h1>
      </Container>
      <Container style={{textAlign: "center"}} >
        <Image src={Hello} className="helloMyNameIs" />
      </Container>
      <section className="formEntry">

        <Container >
          <Row>
            <h3>Talk to the Moon</h3>
            <p>
              Feel free to reach out to me if you're intrested in creative collabs,
              commission work, or you'd just like to share you Delinquent Dreamer
              story!
            </p>
          </Row>
        </Container>

        <Container>
          <Row>
            <Form className="formInput" onSubmit={sendEmail}>
              <Form.Group controlId="enterName">
                <Form.Label>Name{redStar}</Form.Label>
                <Form.Control type="text" placeholder="Name" name="name" />
              </Form.Group>
              <Form.Group controlId="formGroupEmail">
                <Form.Label>Email{redStar}</Form.Label>
                <Form.Control type="email" placeholder="Email" name="email" />
              </Form.Group>
              <Form.Group controlId="enterSubject">
                <Form.Label>Subject{redStar}</Form.Label>
                <Form.Control type="text" placeholder="Email Subject" name="subject" />
              </Form.Group>
              <Form.Group controlId="exampleForm ControlTextarea1">
                <Form.Label>Message{redStar}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Write to Moon, add as much detail as you'd like"
                  name="message"
                />
              </Form.Group>
              <Button type="submit" variant="danger" className="styleButton" value="Send" size="lg">
                Submit
              </Button>
            </Form>
          </Row>
        </Container>
      </section>
    </>
  );
}
